var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignedToBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.666626,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#2999BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4584 15.0416C15.9982 15.0416 15.6251 15.4147 15.6251 15.875V17.125H14.3751C13.9148 17.125 13.5417 17.498 13.5417 17.9583C13.5417 18.4185 13.9148 18.7916 14.3751 18.7916H15.6251V20.0416C15.6251 20.5019 15.9982 20.875 16.4584 20.875C16.9187 20.875 17.2917 20.5019 17.2917 20.0416V18.7916H18.5417C19.002 18.7916 19.3751 18.4185 19.3751 17.9583C19.3751 17.498 19.002 17.125 18.5417 17.125H17.2917V15.875C17.2917 15.4147 16.9187 15.0416 16.4584 15.0416Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.487 11.8583C13.2543 11.8583 14.687 10.4255 14.687 8.65825C14.687 6.89096 13.2543 5.45825 11.487 5.45825C9.7197 5.45825 8.28699 6.89096 8.28699 8.65825C8.28699 10.4255 9.7197 11.8583 11.487 11.8583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9313 18.7918C12.7895 18.5467 12.7083 18.2621 12.7083 17.9585C12.7083 17.038 13.4545 16.2918 14.375 16.2918H14.7917V15.8752C14.7917 15.1084 15.3094 14.4626 16.0144 14.2683C14.856 13.109 13.2552 12.3918 11.4869 12.3918C9.06424 12.3918 6.95594 13.738 5.86928 15.7231C5.02065 17.2734 6.51807 18.7918 8.28536 18.7918H12.9313Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedToBlue);
export default __webpack_public_path__ + "static/media/assignedToBlue.d2f7511e3ec8532e7c04b0db4113fe4e.svg";
export { ForwardRef as ReactComponent };